//@ts-nocheck
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { addTriggeredEvent } from "./../actions/UserActions";

/**
 * A Higher-Order Function that accepts a component, an event name and details,
 * -- logs user access to the component in the database through the "addTriggeredEvent" action
 * -- Currently, event/access is logged when the TrackerWrapper mounts
 * -- TODO: include log for when a component is detected in the viewport using React Visibility Sensor 
 * (https://www.digitalocean.com/community/tutorials/react-components-viewport-react-visibility-sensor)
 * @param WrappedComponent
 * @param eventname
 * @param details
 */
export const withUserActionTracker = (WrappedComponent, eventname: string, details: string) => {

    const TrackerWrapper = (props) => {
        const { username, display_id } = useSelector(state => state.userProperties)

        const dispatch = useDispatch();

        useEffect(() => {
            dispatch(addTriggeredEvent(eventname, username, display_id, details))
        }, [])

        return <WrappedComponent {...props} />;
    }

    return TrackerWrapper;
}